/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Address } from '../models/address';
import { createAddress } from '../fn/address/create-address';
import { CreateAddress$Params } from '../fn/address/create-address';
import { deleteAddress } from '../fn/address/delete-address';
import { DeleteAddress$Params } from '../fn/address/delete-address';
import { findAddress } from '../fn/address/find-address';
import { FindAddress$Params } from '../fn/address/find-address';
import { updateAddress } from '../fn/address/update-address';
import { UpdateAddress$Params } from '../fn/address/update-address';

@Injectable({ providedIn: 'root' })
export class AddressService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAddress()` */
  static readonly FindAddressPath = '/api/addresses/{id}';

  /**
   * Return address by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAddress()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAddress$Response(params: FindAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<Address>> {
    return findAddress(this.http, this.rootUrl, params, context);
  }

  /**
   * Return address by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAddress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAddress(params: FindAddress$Params, context?: HttpContext): Observable<Address> {
    return this.findAddress$Response(params, context).pipe(
      map((r: StrictHttpResponse<Address>): Address => r.body)
    );
  }

  /** Path part for operation `updateAddress()` */
  static readonly UpdateAddressPath = '/api/addresses/{id}';

  /**
   * Updates a address with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAddress()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAddress$Response(params: UpdateAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateAddress(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a address with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAddress$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAddress(params: UpdateAddress$Params, context?: HttpContext): Observable<void> {
    return this.updateAddress$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createAddress()` */
  static readonly CreateAddressPath = '/api/addresses/{id}';

  /**
   * Creates an address with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAddress()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAddress$Response(params: CreateAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createAddress(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates an address with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAddress$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAddress(params: CreateAddress$Params, context?: HttpContext): Observable<void> {
    return this.createAddress$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteAddress()` */
  static readonly DeleteAddressPath = '/api/addresses/{id}';

  /**
   * Delete an address with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAddress()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAddress$Response(params: DeleteAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAddress(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete an address with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAddress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAddress(params: DeleteAddress$Params, context?: HttpContext): Observable<void> {
    return this.deleteAddress$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
